// extracted by mini-css-extract-plugin
module.exports = {"container":"_3X71hij392FEeXENf_RIGR","icon":"_2LWG23qbX6FlqaMsHyzebd"};